/**
 * 是否生产环境
 * 可以用于控制某些测试组件的显隐状态
 * @type {boolean}
 */
export const isProd = process.env.ENV_CONFIG === 'prod'

/**
 * 目前的使用环境只有三个PC、移动（包括微信端和App）
 * @type {boolean}
 */
export const isDesktop = document.body.clientWidth > 1024

/**
 * 微信环境判断
 * @type {boolean}
 */
export const isWeixin = navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1

export function getAccessType() {
  let AccessType = ''
  const isApp = navigator.userAgent.toLowerCase().match(/isapp/i) === 'isapp'
  if (isDesktop) {
    AccessType = 'webchat'
  } else {
    AccessType = 'h5'
  }
  if (isWeixin) {
    AccessType = 'wechat'
  }
  if (isApp) {
    AccessType = 'app'
  }
  return AccessType
}
/**
 * 获取格式化后的时间字符串
 * 默认为当前时间的yyyy-MM-dd hh:mm:ss
 * @param fmt
 * @param date
 * @return {string}
 */
export function getDateFormat(fmt = 'yyyy-MM-dd hh:mm:ss', date = new Date()) {
  const o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (`${date.getFullYear()}`).substr(4 - RegExp.$1.length))
  }

  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : ((`00${o[k]}`).substr((`${o[k]}`).length)))
    }
  }
  return fmt
}

/**
 * 提供一个默认format 的时间字符串
 * yyyy-MM-ddThh:mm:ss
 * @return {*|void|string|never}
 */
export function getDatetime() {
  return getDateFormat('yyyy-MM-ddThh:mm:ss', new Date())
}

/**
 * 格式化时间
 * 例如：2018-12-12 0:0
 * @param time
 * @param cFormat
 * @return {*}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let data
  if (typeof time === 'object') {
    data = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000
    data = new Date(time)
  }
  const formatObj = {
    y: data.getFullYear(),
    m: data.getMonth() + 1,
    d: data.getDate(),
    h: data.getHours(),
    i: data.getMinutes(),
    s: data.getSeconds(),
    a: data.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

export function formatTime(time, option) {
  time = +time * 1000
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}

export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

/**
 * 当前桌面窗口居中，打开一个浏览器窗口
 * @param url
 * @param w
 * @param h
 * @return {Window}
 */
export function windowOpenWithProperty(url, w = 640, h = 720) {
  const left = ((window.innerWidth / 2) - (w / 2)) + window.screenLeft
  const top = ((window.innerHeight / 2) - (h / 2)) + window.screenTop

  return window.open(url, 'image-view', `width=${w},height=${h},resizable,scrollbars=yes,location=no,left=${left},top=${top}`)
}

/**
 *get getByteLen
 * @param {Sting} val input value
 * @returns {number} output value
 */
export function getByteLen(val) {
  let len = 0
  for (let i = 0; i < val.length; i++) {
    if (val[i].match(/[^\x00-\xff]/ig) != null) {
      len += 1
    } else { len += 0.5 }
  }
  return Math.floor(len)
}

export function cleanArray(actual) {
  const newArray = []
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i])
    }
  }
  return newArray
}

/**
 * 获取form-url-encode string
 * @param json
 * @return {string}
 */
export function param(json) {
  if (!json) return ''
  return cleanArray(Object.keys(json).map(key => {
    if (json[key] === undefined) return ''
    return encodeURIComponent(key) + '=' +
            encodeURIComponent(json[key])
  })).join('&')
}

export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
}

export function html2Text(val) {
  const div = document.createElement('div')
  div.innerHTML = val
  return div.textContent || div.innerText
}

export function objectMerge(target, source) {
  /* Merges two  objects,
     giving the last one precedence */

  if (typeof target !== 'object') {
    target = {}
  }
  if (Array.isArray(source)) {
    return source.slice()
  }
  Object.keys(source).forEach((property) => {
    const sourceProperty = source[property]
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty)
    } else {
      target[property] = sourceProperty
    }
  })
  return target
}

export function capitalize(s) {
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export function scrollTo(element, to, duration, direction = 'top') {
  if (duration <= 0) return
  const directionName = 'scroll' + capitalize(direction)
  const difference = to - element[directionName]
  const perTick = difference / duration * 10
  setTimeout(() => {
    element[directionName] = element[directionName] + perTick
    if (element[directionName] === to) return
    scrollTo(element, to, duration - 10, direction)
  }, 10)
}

export function scrollToDelta(element, delta, duration = 200, direction = 'top') {
  const directionName = 'scroll' + capitalize(direction)
  const to = element[directionName] + delta
  scrollTo(element, to, duration, direction)
}

export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90
  } else {
    return new Date(new Date().toDataString())
  }
}

export function getTimeValue() {
  const h = new Date().getHours()
  if (h <= 12) {
    return '上午好'
  } else if (h <= 17) {
    return '下午好'
  } else if (h <= 24) {
    return '晚上好'
  }
}

export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result

  const later = function() {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔last小于设定时间间隔wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }

  return function(...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'shallowClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach((keys) => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

/**
 * 生成唯一ID
 * @param prefix
 * @return {string}
 */
export function uuid(prefix = 'id') {
  return `${prefix}_${Math.random().toString(36).substr(2)}`
}

// 获取地址栏参数
export function getQueryString(name) {
  const after = window.location.hash.split('?')[1]
  if (after) {
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
    const r = after.match(reg)
    if (r != null) {
      return decodeURIComponent(decodeURIComponent(r[2]))
    } else {
      return null
    }
  }
}

export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * 一个方便的延迟Promise
 * @param delay
 * @return {Promise<any>}
 */
export function sleep(delay) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve('timeup')
    }, delay || 1000)
  })
}

export function filterObj(objcArray) {
  for (let i = 0; i < objcArray.length; i++) {
    for (let j = i + 1; j < objcArray.length;) {
      if (objcArray[i].id === objcArray[j].id) { // 通过id属性进行匹配；
        objcArray.splice(j, 1) // 去除重复的对象；
      } else {
        j++
      }
    }
  }
  return objcArray
}
// 修改地址栏参数  changeURLArg(window.location.href,'name',123)
/* eslint-disable */
export function changeURLArg(url, arg, arg_val) {
  let pattern = arg + '=([^&]*)'
  let replaceText = arg + '=' + arg_val
  if (url.match(pattern)) {
    let tmp = '/(' + arg + '=)([^&]*)/gi'
    tmp = url.replace(eval(tmp), replaceText)
    return tmp
  } else {
    if (url.match('[\?]')) {
      return url + '&' + replaceText
    } else {
      return url + '?' + replaceText
    }
  }
}

/**
 * 消息会话时间显示
 */
export const timeFormat = (date) => {
  if (!date) return ''
  let newtime
  let nowtime = new Date()
  if (date.constructor !== Date) {
    date = new Date(date.replace(/\-/g, '/')) // 解决ios日期显示NAN问题
  }
  date = new Date(date)
  // 获取消息发送时间
  let Y = date.getFullYear()
  let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  let W = date.getDay()
  let H = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  let Min = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  // 获取当前时间
  let nowY = nowtime.getFullYear()
  let nowM = nowtime.getMonth() + 1 < 10 ? '0' + (nowtime.getMonth() + 1) : nowtime.getMonth() + 1
  let nowD = nowtime.getDate() < 10 ? '0' + nowtime.getDate() : nowtime.getDate()
  let isWeek = Math.abs(date - nowtime) < 7 * 24 * 3600 * 1000
  if (Y < nowY) {
    // 去年
    newtime = Y + '-' + M + '-' + D
  } else {
    if (Y === nowY && M === nowM && (nowD - D <= 7)) {
      // 昨天
      if ((nowD - D) === 1) {
        newtime = '昨天'
      } else if (nowD === D) {
        // 当天
        newtime = H + ':' + Min
      } else {
        // 一周内
        newtime = weekFormat(W)
      }
    }
    if (isWeek) {
      newtime = weekFormat(W)
    } else {
      // 一年内
      newtime = M + '-' + D
    }
  }
  return newtime
}

// 消息按时间排序
export const compare = (pro) => {
  return function (obj1, obj2) {
    var val1 = obj1[pro]
    var val2 = obj2[pro]
    if (val1 < val2) {
      return 1
    } else if (val1 > val2) {
      return -1
    } else {
      return 0
    }
  }
}
// 星期
export const weekFormat = (num) => {
  let str
  switch (num) {
    case 1:
      str = '星期一'
      break
    case 2:
      str = '星期二'
      break
    case 3:
      str = '星期三'
      break
    case 4:
      str = '星期四'
      break
    case 5:
      str = '星期五'
      break
    case 6:
      str = '星期六'
      break
    default:
      str = '星期天'
  }
  return str
}

function numberFormat(n) {
  const str = n.toString()
  return str[1] ? str : `0${str}`
}
/**
 * 时间格式化方法
 */
export const dateFormat = (date, fmt) => {
  if (!date) return ''
  if (date.constructor !== Date) {
    date = new Date(date)
  }
  const o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
    'S': date.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}
export const setTime = (time) => {
  const currentTime = Date.parse(new Date())
  const dateTime = time // 后台传递来的时间
  const d_day = Date.parse(new Date(dateTime))
  const day = Math.abs(parseInt((d_day - currentTime) / 1000 / 3600 / 24)) // 计算日期
  const hour = Math.abs(parseInt((d_day - currentTime) / 1000 / 3600)) // 计算小时
  const minutes = Math.abs(parseInt((d_day - currentTime) / 1000 / 60)) // 计算分钟
  const seconds = Math.abs(parseInt((d_day - currentTime) / 1000)) // 计算秒
  if (day >= 2) {
    time = parseInt(day) + '天前'
  } else if (day > 0 && day < 2) {
    time = '昨天'
  } else if (hour > 0 && hour < 24) {
    time = parseInt(hour) + '小时前'
  } else if (minutes > 1 && minutes < 60) {
    time = parseInt(minutes) + '分钟前'
  } else if (seconds > 0 && seconds < 60) {
    time = ''
    // time = parseInt(seconds) + '秒前'
  } else {
    time = ''
  }
  return time
}

/**
 * 提供常用的正则表达式
 * @type {{url: RegExp}}
 */
export const RegexUtil = {
  url: /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/,
  // mobile: /^(9|90|0)?1[3456789]\d{9}$/,
  mobile: /^0?1[3456789]\d{9}$|^((0\d{2,3})-?)(\d{7,8})(-(\d{3,}))?$|^\d{6}?$/,
  telephone: /^0?1[3456789]\d{9}$|^((0\d{2,3})-?)(\d{7,8})(-(\d{3,}))?$|^\d{6}?$/,
  hotline: /^400\d{7}$/,
  email: /^[a-zA-Z0-9]+([._\-]*[a-zA-Z0-9])*@([a-zA-Z0-9]+[-a-zA-Z0-9]*[a-zA-Z0-9]+.){1,63}[a-zA-Z0-9]+$/,
  externalProtocol: /^(https?:|mailto:|tel:)/,
  regularInput: /^[\w\u4e00-\u9fa5]+$/,
  onlyChineseInput: /^[\u4e00-\u9fa5]+$/,
  onlyNumberInput: /^[\d]+$/
}


// WEBPACK FOOTER //
// ./src/utils/index.js